const screens = {
  xs: '320px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
}

export default ({ app }, inject) => {
  inject('matchMedia', (media) => {
    const mediaQuery = `(min-width: ${screens[media]})`
    const mediaQueryList = window.matchMedia(mediaQuery)

    if (mediaQueryList.matches) {
      // Viewport is less or equal to media
      return true
    } else {
      // Viewport is greater than media
      return false
    }
  })
}
